/* eslint-disable import/prefer-default-export */
/* eslint-disable multiline-ternary */
import styled, { css } from 'styled-components';

import Typography from '../Typography';

export const QuoteContainer = styled.blockquote`
  /* With the border */
  && {
    ${({ theme, borderColor, hasBorder }) => (hasBorder
    && css`
      border-left: 5px solid ${borderColor};
      padding-left: ${theme.spacing(3).rem()};
    `)}
  }
  /* default */
  && {
    ${({ theme }) => css`
      margin-left:0;
      margin-right:0;
    `}
  }
`;

export const QuoteTypography = styled(Typography)`
  && {
    && {
      ${({ theme }) => css`
        font-weight:400;
      `}
    }
  }
`;

export const QuoteFigure = styled.figure`
  ${({ theme }) => css`
    margin:0;
  `}
`;

